// helpers


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// CartManager
class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
      options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
              'To add a new item both properties: ID & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
              'To update an existing item, both properties: KEY & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
        nextRequest.formData,
        nextRequest.action,
        nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
        `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then(function (cart) {
        try {
          options.onSuccess();
        } catch (e) {
          console.error(
            'Error executing onSuccess callback from postShopify',
            e,
          );
        }

        return {cart};
      })
      .catch(function (error) {
        self.handleErrors(error);

        try {
          options.onFailure();
        } catch (e) {
          console.error(
            'Error executing onFailure callback from postShopify',
            e,
          );
        }

        return {err: error};
      })
      .finally(function () {
        try {
          options.always();
        } catch (e) {
          console.error('Error executing always callback from postShopify', e);
        }

        // Handle next request if there are any in the queue.
        if (self.requestsQueue.length) {
          const nextRequest = self.requestsQueue.pop();
          return self.postShopify(nextRequest.formData, nextRequest.action);
        }
      });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

// Remove Button
customElements.define(
  'cart-remove-button',
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.removeEvent = new Event('remove', {bubbles: true});
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.dataset.checkboxUncheck === '1') {
          document.querySelector('[data-checkbox-gift-input]').click();
        } else {
          this.dispatchEvent(this.removeEvent);
        }
      });
    }
  },
);

// Cart items
customElements.define(
  'cart-items',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        variantSelects: 'variant-selects',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.variantSelects = document.querySelectorAll(
        this.selectors.variantSelects,
      );

      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0,
      );

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.addEventListener('remove', (event) => {
				const removeAdhesion = event.target.dataset?.isAdhesion === 'true'
				if (removeAdhesion) {
					this.updateQuantityAdhesion({
							line: event.target.dataset.index,
							quantity: 0,
							name: document.activeElement.getAttribute('name')
						}
					);
				} else {
					this.updateQuantity(
						event.target.dataset.index,
						0,
						document.activeElement.getAttribute('name'),
						(event.target.dataset != null && event.target.dataset.removeGift != null) ? this.removeGift.bind(this) : ''
					);
				}
      });
    }

		connectedCallback() {
			this.handleCartUpdateBound = this.handleCartUpdate.bind(this);
			document.body.addEventListener('cart:update', this.handleCartUpdateBound);

			this.handleClubPurple()
		}

		disconnectedCallback() {
			if (this.handleCartUpdateBound) {
				document.body.removeEventListener('cart:update', this.handleCartUpdateBound);
			}
		}

		handleCartUpdate(event) {
			this.cartJSON = event.detail?.cart || null;

			this.handleClubPurple()
		}

		async handleClubPurple() {
			this.cartDrawer = this.closest('cart-drawer-z');
			const scriptClubPurpleJSON = this.cartDrawer?.querySelector('#clubPurpleJSON');

			if (!scriptClubPurpleJSON) {
				console.error('ClubPurpleJSON script not found');
				return;
			}

			try {
				this.clubPurpleJSON = JSON.parse(scriptClubPurpleJSON.innerHTML);

				const {
					is_purple_member: isPurpleMember,
					card_product_adhesion: cardProductAdhesion,
					gift_product_adhesion: giftProductAdhesion,
					existed_adhesion_in_cart: existedAdhesionInCart,
					enabled_gift_spend: enabledGiftSpend,
					gifts_ids_variants: giftsIdsVariants,
					gifts_variants_quantity: giftsVariantsQuantity,
				} = this.clubPurpleJSON;

				this.isPurpleMember = isPurpleMember;
				this.cardProductAhesion = cardProductAdhesion;
				this.giftProductAdhesion = giftProductAdhesion;
				this.existedAdhesionInCart = existedAdhesionInCart;
				this.enabledGiftSpend = enabledGiftSpend;
				this.giftsIdsVariants = giftsIdsVariants;
				this.giftsVariantsQuantity = giftsVariantsQuantity;

				if (!this.onProcessGiftSpend) {
					try {
						this.onProcessGiftSpend = true;
						if (!this.cartJSON) this.cartJSON = await cartManager.getCart();

						if (this.enabledGiftSpend) {
							const existingGiftItems = this.cartJSON?.items.filter(item => item.properties?._gift_club) || [];
							const giftsToAdd = [];

							this.giftsIdsVariants.forEach((variantId, index) => {
								if (!existingGiftItems.some(item => item.variant_id === variantId)) {
									giftsToAdd.push({
										id: variantId,
										quantity: this.giftsVariantsQuantity[index] || 1,
										properties: { _gift_club: '100' }
									});
								}
							});

							if (giftsToAdd.length > 0) {
								await this.addItem(giftsToAdd, false);
							}
						} else {
							const itemsToRemove = {};
							const itemsGiftClub = this.cartJSON?.items.filter(item => item.properties?._gift_club) || [];

							itemsGiftClub.forEach(item => {
								itemsToRemove[item.key] = 0;
							});

							if (Object.keys(itemsToRemove).length > 0) {
								await this.fetchCartUpdate(
									itemsToRemove,
									true,
									document.activeElement?.getAttribute('name') || null,
									null
								);
							}
						}
					} catch (error) {
						console.error('Erreur lors du traitement des cadeaux:', error);
					} finally {
						this.onProcessGiftSpend = false;
					}
				}

				// Remove card and gift, if customer is purple
				if (this.isPurpleMember && this.existedAdhesionInCart) {
					await this.updateQuantityAdhesion({
						line: null,
						quantity: 0,
						name: document.activeElement.getAttribute('name'),
						openDrawer: false
					});
				}

				// Remove gift if gift has changed
				if (this.existedAdhesionInCart && !this.onProgressClub) {
					if (!this.cartJSON) this.cartJSON = await cartManager.getCart();
					const itemsGiftClub = this.cartJSON?.items.filter(item => item.properties?._discount_club) || [];
					const hasGiftClubItemMismatch = itemsGiftClub.length > 0 &&
						this.giftProductAdhesion?.id !== itemsGiftClub[0]?.variant_id;

					if (hasGiftClubItemMismatch) {
						this.onProgressClub = true;
						await this.updateQuantityAdhesion({
							line: null,
							quantity: 0,
							name: document.activeElement.getAttribute('name'),
							openDrawer: false,
							onlyGift: true,
							refreshContent: false
						});

						const itemsToAdd = [];

						if (this.giftProductAdhesion?.available) {
							itemsToAdd.push({
								id: this.giftProductAdhesion?.id,
								quantity: 1,
								properties: {
									_discount_club: '100'
								}
							});
						} else {
							console.warn('Gift product adhesion is not available.');
						}

						await this.addItem(itemsToAdd, false);
						this.onProgressClub = false;
					}
				}
			} catch (error) {
				console.error('Error parsing ClubPurpleJSON:', error);
				return;
			}
		}

		removeGift() {
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name'),
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
				{
					id: 'cart-drawer-json-club',
					section:
						document.getElementById('cart-drawer-json-club') != null
							? document.getElementById('cart-drawer-json-club').dataset.id
							: null,
					selector: '[data-drawer-json-club]',
				},
        {
          id: 'cart-drawer-reward',
          section: document.getElementById('cart-drawer-reward') != null
                    ? document.getElementById('cart-drawer-reward').dataset.id
                    : null,
          selector: '[data-cart-drawer-reward]',
        },
        {
          id: 'cart-drawer-samples',
          section: document.getElementById('cart-drawer-samples') != null
                    ? document.getElementById('cart-drawer-samples').dataset.id
                    : null,
          selector: '[data-cart-drawer-samples]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell',
          section:
            document.getElementById('drawer-cart-upsell') != null
              ? document.getElementById('drawer-cart-upsell').dataset.id
              : null,
          selector: '[data-upsell-cart-drawer]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        },
				{
					id: 'cart-drawer-checkbox-club',
					section:
						document.getElementById('cart-drawer-checkbox-club') != null
							? document.getElementById('cart-drawer-checkbox-club').dataset.id
							: null,
					selector: '[data-cart-checkbox-club]',
				},
				{
					id: 'cart-drawer-checkbox-gift',
					section:
						document.getElementById('cart-drawer-checkbox-gift') != null
							? document.getElementById('cart-drawer-checkbox-gift').dataset.id
							: null,
					selector: '[data-cart-checkbox-gift]',
				}
      ];
    }

    updateQuantity(line, quantity, name, callback) {
      this.enableLoading(line);
			document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'true');

      localStorage.setItem('productUpdated', true);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch('/cart/change', {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.text();
        })
        .then((state) => {

          //
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter)
            cartFooter.classList.toggle(
              'is-empty',
              parsedState.item_count === 0,
            );

          this.cartNotifications.forEach((section) => {
            if (parsedState.item_count) {
              section.updateItemsCount(parsedState.item_count);
            }
          });

          this.variantSelects.forEach((section) => {
            section.reset();
          });

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector,
                );
              }
            }
          });

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`))
            lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading(line);

          if (callback && typeof callback == 'function') {
            callback();
          };
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) =>
            overlay.classList.add('hidden'),
          );
          this.disableLoading(line);
        }).finally(() => {
					document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'false');
			});
    }

    async updateQuantityAdhesion({line, quantity, name, openDrawer = true, onlyGift = false, refreshContent = true}) {
			this.enableMultipleLoadingClub()
			document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'true');

      document.activeElement?.blur();

			if (!this.cartJSON) this.cartJSON = await cartManager.getCart();

			if (refreshContent) {
				localStorage.setItem('productUpdated', true);
			} else {
				localStorage.setItem('productUpdatedNoRefresh', true);
			}

			if (!openDrawer) {
				localStorage.setItem('productUpdatedRestrictionClub', true);
			}

			const itemsCardAdhesion = this.cartJSON?.items.filter(item => item.properties?._is_adhesion) || [];
			const itemsGiftClub = this.cartJSON?.items.filter(item => item.properties?._discount_club) || [];

			if (line === null) {
				const itemsCardAdhesionIndex = this.cartJSON?.items.findIndex(item => item.properties?._is_adhesion);
				const adjustedIndex = itemsCardAdhesionIndex >= 0 ? itemsCardAdhesionIndex + 1 : -1;
				if (adjustedIndex >= 0) {
					line = this.cartJSON?.items.findIndex(item => item.properties?._is_adhesion);
				}
			}

      let updates = {};

			if (!onlyGift) {
				itemsCardAdhesion.forEach(item => {
					updates[item.key] = quantity;
				});
			}

			itemsGiftClub.forEach(item => {
				updates[item.key] = quantity;
			});

			await this.fetchCartUpdate(updates, refreshContent, name, line);
    }

		async fetchCartUpdate(updates, refreshContent, name, line) {
			const body = JSON.stringify({
				updates,
				sections: this.getSectionsToRender()
					.map((section) => section.section)
					.filter(Boolean),
				sections_url: window.location.pathname
			});

			await fetch(window.routes.cart_update_url, { ...fetchConfig(), body })
				.then((response) => response.text())
				.then((state) => {
					const parsedState = JSON.parse(state);
					this.classList.toggle('is-empty', parsedState.item_count === 0);
					const cartFooter = document.getElementById('main-cart-footer');

					if (cartFooter) {
						cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
					}

					this.cartNotifications.forEach((section) => {
						if (parsedState.item_count) {
							section.updateItemsCount(parsedState.item_count);
						}
					});

					this.variantSelects.forEach((section) => {
						section.reset();
					});

					if (refreshContent) {
						this.getSectionsToRender().forEach((section) => {
							if (section.section != null) {
								const elementToReplace =
									document
										.getElementById(section.id)
										?.querySelector(section.selector) ||
									document.getElementById(section.id);
								if (elementToReplace != null) {
									elementToReplace.innerHTML = this.getSectionInnerHTML(
										parsedState.sections[section.section],
										section.selector
									);
								}
							}
						});
					}

					const lineItem = document.getElementById(`CartItem-${line}`);
					if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
						lineItem.querySelector(`[name="${name}"]`).focus();
					}
					this.disableLoading(line);
				})
				.catch(() => {
					this.querySelectorAll('.loading-overlay').forEach((overlay) =>
						overlay.classList.add('hidden')
					);
					this.disableLoading(line);
				}).finally(() => {
					this.disableMultipleLoadingClub();
					document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'false');
				});
		}

		async addItem(itemsToAdd, openDrawer = true) {
			if (itemsToAdd.length === 0) {
				console.warn('No products available to add.');
				return;
			}

			document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'true');

			this.enableMultipleLoadingClub()

			if (!openDrawer) {
				localStorage.setItem('productUpdatedRestrictionClub', true);
			}

			const formData = { items: itemsToAdd };

			try {
				const response = await fetch(window.routes.cart_add_url, {
					...fetchConfig(),
					body: JSON.stringify(formData)
				});

				if (!response.ok) {
					throw new Error(`Failed to add items. Status: ${response.status}`);
				}
			} catch (error) {
				console.error('Error adding item:', error);
			} finally {
				this.disableMultipleLoadingClub()
				document.querySelector('cart-drawer-checkout-button')?.setAttribute('aria-disabled', 'false');
			}
		}

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
        (overlay) => overlay.classList.remove('hidden'),
      );
      this.querySelector(`#CartItem-${line}`).classList.add('updating');
      document.activeElement.blur();
    }

    disableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.remove('cart__items--disabled');
        if (this.querySelector(`#CartItem-${line}`) != null) {
          this.querySelector(`#CartItem-${line}`).classList.remove('updating');
        }
    }

		enableMultipleLoadingClub() {
			const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) {
        mainCartItems.classList.add('cart__items--disabled');
      }

      this.querySelectorAll(`.cart-drawer_item-container[data-adhesion-club="true"]`).forEach(container => {
        container?.classList.add('updating');
        container?.querySelectorAll('.loading-overlay').forEach(overlay => overlay?.classList.remove('hidden'));
      });
		}

		disableMultipleLoadingClub() {
			const mainCartItems = document.getElementById('main-cart-items');
			if (mainCartItems) {
				mainCartItems.classList.remove('cart__items--disabled');
			}

			this.querySelectorAll(`.cart-drawer_item-container[data-adhesion-club="true"]`).forEach(container => {
				container?.classList.remove('updating');
				container?.querySelectorAll('.loading-overlay').forEach(overlay => overlay?.classList.add('hidden'));
			});
		}
  },
);

// Quantity
customElements.define(
  'cart-quantity-input',
  class CartQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', {bubbles: true});

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this)),
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus'
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  },
);

// Cart notification
customElements.define(
  'cart-notification',
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartCount: '[data-cart-count]',
      };
      this.selectors = selectors;
      this.cartNotification = this.querySelector(this.selectors.cartCount);
    }

    updateItemsCount(itemsCount) {
      if (!this.cartNotification) return;

      this.cartNotification.innerHTML = itemsCount;
    }

    getItemsCount() {
      if (!this.cartNotification) return;
      return this.cartNotification.innerHTML;
    }
  },
);

// Cart Drawer
customElements.define(
  'cart-drawer-z',
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartOpen: '[data-cart-drawer-open]',
        cartClose: '[data-cart-drawer-close]',
        cartDrawer: 'cart-drawer-v2',
        cartOverlay: 'cart-overlay',
        cartNotification: 'cart-notification',
        cartUpsellDynamic: 'cart-upsell-dynamic',
      };

      this.selectors = selectors;
      this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
      this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.cartUpsellDynamic = document.querySelector(
        this.selectors.cartUpsellDynamic,
      );

      this.cartDrawer.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close(),
      );

      document
        .querySelectorAll(this.selectors.cartOpen)
        .forEach((cartOpen) =>
          cartOpen.addEventListener('click', this.handleCartUpdates.bind(this), false),
        );

      this.init();
    }

    init() {
      // Detect cart interactions
      this.httpInterceptor(
        [
          '/cart/add.js',
          '/cart/add',
          '/cart/change',
          '/cart/update',
          '/cart/clear',
        ],
        this.handleCartUpdates.bind(this),
      );
    }

    open() {
      this.cartDrawer.classList.add('animate', 'active');
      this.cartOverlay.classList.add('animate', 'active');
      document.querySelector('body').style.overflow = 'hidden';
    }

    close() {
      this.cartDrawer.classList.remove('active');
      this.cartOverlay.classList.remove('active');
      document.querySelector('body').style.overflow = 'scroll';

      if (window.location.href.indexOf('/cart') > -1) {
        window.location.href = "/"
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
				{
					id: 'cart-drawer-json-club',
					section:
						document.getElementById('cart-drawer-json-club') != null
							? document.getElementById('cart-drawer-json-club').dataset.id
							: null,
					selector: '[data-drawer-json-club]',
				},
        {
          id: 'cart-drawer-reward',
          section: document.getElementById('cart-drawer-reward') != null
                    ? document.getElementById('cart-drawer-reward').dataset.id
                    : null,
          selector: '[data-cart-drawer-reward]',
        },
        {
          id: 'cart-drawer-samples',
          section: document.getElementById('cart-drawer-samples') != null
                    ? document.getElementById('cart-drawer-samples').dataset.id
                    : null,
          selector: '[data-cart-drawer-samples]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        },
        {
          id: 'drawer-cart-upsell',
          section:
            document.getElementById('drawer-cart-upsell') != null
              ? document.getElementById('drawer-cart-upsell').dataset.id
              : null,
          selector: '[data-upsell-cart-drawer]',
        },
				{
					id: 'cart-drawer-checkbox-club',
					section:
						document.getElementById('cart-drawer-checkbox-club') != null
							? document.getElementById('cart-drawer-checkbox-club').dataset.id
							: null,
					selector: '[data-cart-checkbox-club]',
				},
				{
					id: 'cart-drawer-checkbox-gift',
					section:
						document.getElementById('cart-drawer-checkbox-gift') != null
							? document.getElementById('cart-drawer-checkbox-gift').dataset.id
							: null,
					selector: '[data-cart-checkbox-gift]',
				}
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async renderContents(openDrawer = true) {
      await fetch('/?sections=cart-drawer-v2', {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {
					this.getSectionsToRender().forEach((section) => {
						if (section.section != null) {
							const elementToReplace =
								document
									.getElementById(section.id)
									.querySelector(section.selector) ||
								document.getElementById(section.id);
							if (elementToReplace != null) {
								elementToReplace.innerHTML = this.getSectionInnerHTML(
									response['cart-drawer-v2'],
									section.selector
								);
							}
						}
					});

					this.cartNotifications.forEach((section) => {
						const newNotification = new DOMParser()
							.parseFromString(response['cart-drawer-v2'], 'text/html')
							.querySelector('[data-cart-count]');
						if (newNotification) {
							section.updateItemsCount(newNotification.innerHTML);
						}
					});

					document
						.querySelectorAll(this.selectors.cartClose)
						.forEach((cartClose) =>
							cartClose.addEventListener('click', this.close.bind(this))
						);

					if (document.querySelector('#cart-progressbar-rewards') != null) {
						this.cartProgressBarSampless = document.querySelector('#cart-progressbar-rewards');
						this.cartProgressBarSampless.init();
					}
					if (document.querySelector('#cart-drawer-shipping-estimate') != null) {
						this.cartProgressBarSampless = document.querySelector('#cart-drawer-shipping-estimate');
						this.cartProgressBarSampless.init();
					}
        })
        .catch((error) => {
          console.error('Error:', error);
        });

			if (openDrawer) {
				this.open();
			}
    }

    async handleCartUpdates(res, url) {


      const EVENTS = {
        CART_UPDATE                       : "cart:update",
        CART_UPDATE_ADD                   : "cart:update:add",
        CART_UPDATE_CLEAR                 : "cart:update:clear",
        CART_UPDATE_MODIFY                : "cart:update:update_content",
      }

      if (res != undefined && res.target != undefined && res.target) {
        res.preventDefault();
      }
      const shopifyCart = await cartManager.getCart();
      this.cartNotifications.forEach((section) => {
        section.updateItemsCount(shopifyCart.item_count);
      });

      if(shopifyCart.item_count == 0) {
        this.classList.add('cart-empty');
      } else {
        this.classList.remove('cart-empty');
      }

      let refreshContentsAllow = true;
      let refreshOpenDrawer = true;

      if (localStorage.getItem('noteUpdated')) {
        localStorage.removeItem('noteUpdated');
        refreshContentsAllow = false;
      }
      if (localStorage.getItem('productUpdated')) {
        localStorage.removeItem('productUpdated');
        refreshContentsAllow = true;
      }
			if (localStorage.getItem('productUpdatedNoRefresh')) {
        localStorage.removeItem('productUpdatedNoRefresh');
        refreshContentsAllow = false;
      }
			if (localStorage.getItem('productUpdatedRestrictionClub')) {
        localStorage.removeItem('productUpdatedRestrictionClub');
        refreshOpenDrawer = false;
      }
      if (localStorage.getItem('upsellAdded')) {
        localStorage.removeItem('upsellAdded');
        refreshContentsAllow = false;
      }
      if (localStorage.getItem('rewardAdded')) {
        localStorage.removeItem('rewardAdded');
        refreshContentsAllow = false;
      }
      if (localStorage.getItem('samplesAdded')) {
        localStorage.removeItem('samplesAdded');
        refreshContentsAllow = false;
      }

      if (refreshContentsAllow) {
        await this.renderContents(refreshOpenDrawer);
      }

    /* EVENTS */
    /***********************/
      if (url && typeof url === 'string') {
        var requestVerb = (new URL(url)).pathname.replace(/(\/cart\/)([\D]*)(\.js)?/,function (match, p1,p2,p3) {
          return p2;
        });

        const updateEvent = new CustomEvent(EVENTS.CART_UPDATE, {
					detail: {
						// Ajout des données dans "detail"
						response: res,
						request: requestVerb,
						items_count: shopifyCart.item_count,
						cart: shopifyCart
					}
        });

        document.body.dispatchEvent(updateEvent);

        var updateEventName = false;

        if (requestVerb.includes('update'))
          updateEventName = EVENTS.CART_UPDATE_MODIFY;
        if (requestVerb.includes('clear'))
          updateEventName = EVENTS.CART_UPDATE_CLEAR;

        if (updateEventName) {

          const updateEvent2 = new CustomEvent(updateEventName, {
            // Get the type of the request.
            response: res,
            request: requestVerb,
            items_count: shopifyCart.item_count,
            cart: shopifyCart
          });

          document.body.dispatchEvent(updateEvent2);
        }
      }

    }

    async httpInterceptor(urlmatchs, callback) {
			const self = this;
			var responseMatchesAnyUrl = function(requestUrl, urls) {
				if (!Array.isArray(urls)) urls = [urls];

				for (const url of urls) {
					const urlObj = new URL(requestUrl, window.location.origin);
					if (urlObj.searchParams.has('sca_fetch_cart')) {
						self.renderContents();
						return false
					}

					if (!requestUrl.includes(url)) continue;

					if (urlObj.searchParams.has('sca_process_gifts_bogos-ignore')) {
						return false;
					}

					return true;
				}

				return false;
			};


      // Intercept fetch.
      const constantMock = window.fetch;
      window.fetch = function () {
        return new Promise((resolve, reject) => {
          constantMock
            .apply(this, arguments)
            .then(async (response) => {
              try {
                if (
                  responseMatchesAnyUrl(response.url, urlmatchs) &&
                  response.type != 'cors' &&
                  response.ok
                ) {
                  let json = await response.clone().json();
                  if (typeof callback === 'function') {
                    await callback(json, response.url);
									}
                }
              } catch (err) {
                console.error(
                  'Something went wrong while intercepting cart update',
                  err,
                );
              }
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      };

      // Intercept Ajax.
      let send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener(
          'readystatechange',
          async function () {
            if (
              responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
              this.readyState === 4 &&
              this.status == 200
            ) {
              if (typeof callback === 'function')
                await callback(JSON.parse(this.response), this.responseURL);
            }
          },
          false,
        );
        send.apply(this, arguments);
      };
    }
  },
);


// Checkout button
customElements.define(
  'cart-drawer-checkout-button',
  class cartDrawerCheckoutButton extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', async function() {
					if (this.getAttribute('aria-disabled') === 'true') return;

          const shopifyCart = await cartManager.getCart();
          var items = shopifyCart.items;
          var hasCheckboxGiftItem = false;
          for (var i = 0; i < items.length; i++) {
            if (items[i].properties != undefined && items[i].properties._gift_checkbox) {
                hasCheckboxGiftItem = true;
                console.log('has properties', hasCheckboxGiftItem);
            }
          }

          if (hasCheckboxGiftItem == true) {
            this.updateAttribute('add');
            console.log('has gift item');
          } else {
            this.updateAttribute('remove');
            console.log('has NOT gift item');
          }

          window.location.href = "/checkout";

        })
      }

      async updateAttribute(action) {
        if (action == 'add') {
         var data = JSON.stringify({
            attributes: {
              WrappedOrder: 'Option: Coffret cadeau ?'
            }
          })
        } else {
          var data = JSON.stringify({
            attributes: {
              WrappedOrder: ''
            }
          })
        }
        await fetch("/cart/update", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: data
        }).then((response) => {
            console.log(response);
            return response.text();
        })
        .catch((err) => {
            console.error(err)
        });
    }

  },
);
